import { strategyToExecution } from './strategyToExecution';
import { businessWithoutOwner } from './businessWithoutOwner';
import { predictableSales } from './predictableSales';

export const guides = {
  'strategy-to-execution': {
    title: 'How to Turn Business Strategy Into an Execution Plan That Works',
    description: 'Use Rumelt’s strategy kernel to diagnose the real obstacle, choose coherent actions, assign owners, and review outcomes with a practical 90-day example.',
    eyebrow: 'Strategy and execution',
    summary: 'Move from an ambition to a focused choice, accountable work, and a weekly learning rhythm.',
    minutes: 9,
    lensName: 'Richard Rumelt',
    lensId: '68dfc57c-6830-492c-a360-4fe08b6a9e8d',
    lensContext: 'Work through your diagnosis, guiding policy, and coherent actions with the Rumelt Expert Lens.',
    content: strategyToExecution,
  },
  'business-systems-without-owner': {
    title: 'How to Build a Business That Runs Without You',
    description: 'Map your Critical Client Flow and apply SYSTEMology’s seven stages to transfer routine work, decision rights, and quality checks beyond the founder.',
    eyebrow: 'Business systems',
    summary: 'Make recurring work easier to hand off, test, and improve without depending on the founder for every decision.',
    minutes: 10,
    lensName: 'David Jenyns',
    lensId: 'a0c630fc-56a2-4f5c-a65a-4bf86e9e862d',
    lensContext: 'Use the SYSTEMology Expert Lens to map your flow and prioritize the systems your team needs.',
    content: businessWithoutOwner,
  },
  'predictable-sales-process': {
    title: 'How to Build a Predictable B2B Sales Process',
    description: 'Define an ICP, separate SDR and AE work, qualify honest outbound conversations, and forecast from source-specific evidence using Predictable Revenue.',
    eyebrow: 'B2B sales',
    summary: 'Design a sales process that learns from fit, handoff quality, and buyer evidence.',
    minutes: 10,
    lensName: 'Aaron Ross and Marylou Tyler',
    lensId: '8e8e6380-07ff-44c1-ad31-ecfed81678a1',
    lensContext: 'Explore your ICP, qualification rules, and sales handoffs with the Predictable Revenue Expert Lens.',
    content: predictableSales,
  },
} as const;

export type GuideSlug = keyof typeof guides;
export const guideEntries = Object.entries(guides) as [GuideSlug, (typeof guides)[GuideSlug]][];
